import { useAdminStore } from '@/store/admin'

export function registerPermissionDirective(app) {
  const applyPermission = (el, binding) => {
    const permissionsRequired = binding.value
    if (!Array.isArray(permissionsRequired) || permissionsRequired.length === 0) return

    const adminStore = useAdminStore()
    const isAllowed = permissionsRequired.some((perm) => adminStore.hasPermission(perm))
    const modifiers = binding.modifiers || {}

    // 模式：禁用（保留元素但禁用交互） v-permission.disable="[...]"
    if (modifiers.disable) {
      if (!isAllowed) {
        el.setAttribute('disabled', 'true')
        el.classList?.add?.('is-disabled')
        el.style.pointerEvents = 'none'
        el.style.opacity = el.style.opacity || '0.65'
      } else {
        el.removeAttribute('disabled')
        el.classList?.remove?.('is-disabled')
        el.style.pointerEvents = ''
        if (el.style.opacity === '0.65') el.style.opacity = ''
      }
      return
    }

    // 模式：隐藏（不移除DOM） v-permission.hide="[...]"
    if (modifiers.hide) {
      el.style.display = isAllowed ? '' : 'none'
      return
    }

    // 默认：无权限直接从DOM移除（不可恢复）
    if (!isAllowed) {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el)
      }
    }
  }

  app.directive('permission', {
    mounted(el, binding) { applyPermission(el, binding) },
    updated(el, binding) { applyPermission(el, binding) },
  })
} 